import React from "react";
import "./ContactHeroSection.css";

export default function ContactHeroSection() {
  return (
    <section className="contact-hero">
      <div className="contact-hero-wrapper">

        {/* TITLE */}
        <h1 className="contact-hero-title">
          Let’s Elevate Your Facility Standards
        </h1>

        {/* DESCRIPTION */}
        <p className="contact-hero-desc">
          Our team will assess your site requirements, understand your operational
          challenges and create a custom FM solution that fits your budget and goals.
        </p>

        {/* BREADCRUMB */}
        <p className="contact-hero-breadcrumb">
          Home <span>-</span> Contact Us
        </p>

      </div>
    </section>
  );
}
